import { render, staticRenderFns } from "./PreviewTextMessage.vue?vue&type=template&id=16b61d64&scoped=true&"
import script from "./PreviewTextMessage.vue?vue&type=script&lang=ts&"
export * from "./PreviewTextMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewTextMessage.vue?vue&type=style&index=0&id=16b61d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b61d64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
